exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-customer-badge[data-v-b66e2850] {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  border: 1px rgba(100, 100, 100, 0.6) solid;\n}", ""]);

// exports
